document.addEventListener("DOMContentLoaded", () => {
  const imageCards = document.querySelectorAll(".image-card");
  const popups = document.querySelectorAll("image-popup");

  popups.forEach((popup) => {
    const swiperEl = popup.querySelector(".image-popup-swiper");
    const closeBtn = popup.querySelector(".close-popup");
    const overlay = popup.querySelector(".popup-overlay");

    const swiper = new Swiper(swiperEl, {
      loop: false,
      slidesPerView: 1,
      navigation: {
        nextEl: popup.querySelector(".swiper-button-next"),
        prevEl: popup.querySelector(".swiper-button-prev"),
      },
    });

    const openPopup = (index) => {
      popup.setAttribute("aria-hidden", "false");
      popup.classList.add("active");
      document.body.classList.add("no-scroll");
      swiper.slideTo(index, 0);
    };

    const closePopup = () => {
      popup.setAttribute("aria-hidden", "true");
      popup.classList.remove("active");
      document.body.classList.remove("no-scroll");
    };

    imageCards.forEach((card) => {
      const popupId = card.dataset.popupId;
      if (popupId !== popup.id) return;
      const index = parseInt(card.dataset.index, 10) - 1;

      card.addEventListener("click", () => openPopup(index));
    });

    closeBtn?.addEventListener("click", closePopup);
    overlay?.addEventListener("click", closePopup);
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape" && popup.classList.contains("active")) {
        closePopup();
      }
    });
  });
});
